import { SUBTYPE_FIELD_BY_ALL_CONDITIONS } from '../../new-ui/constants';
import { indicationChooser } from '../../components/Questionnaire/functions';
import { GENERAL_CONDITION } from '../../new-ui/Components/SearchForm';
import { getInitialConditionProfileByIndication } from '../../new-ui/functions';

/**
 * @param indication {{ value: string, type: string }}
 * @return {{diseaseSubTypeField: string, diseaseSubTypeValue: string} | {}}
 */
export const getIndicationParams = (indication) => {
  if (!indication.type) {
    return {};
  }

  return {
    diseaseSubTypeField: SUBTYPE_FIELD_BY_ALL_CONDITIONS[indication.value],
    diseaseSubTypeValue: indication.type,
  };
};

/**
 * @param indication {{ value: string, type: string }}
 * @param conditionProfile {{ qstack: Array.<string> }}
 */
export const removeNonIndicationAttrs = async (indication, conditionProfile) => {
  const profile = {
    qstack: [],
  };

  const questions = await indicationChooser(indication.value, getIndicationParams(indication));

  for (const question of questions) {
    profile[question.id] = question.id in conditionProfile ? conditionProfile[question.id] : null;
    profile.qstack.push(question.id);
  }

  return profile;
};

/**
 * @param indication {{ value: string, type: string }}
 * @param conditionProfile {Object}
 * @return {{}}
 */
export const mixGeneralRelatedAttrs = (indication, conditionProfile) => {
  const { value, type } = indication;

  if (value !== GENERAL_CONDITION) {
    return conditionProfile;
  }

  const attributeName = SUBTYPE_FIELD_BY_ALL_CONDITIONS[indication.value];

  conditionProfile[attributeName] = type ?? null;
  conditionProfile.qstack = [...conditionProfile.qstack, attributeName];

  return conditionProfile;
};

/**
 * Removes non-indication-specific attributes and mixes in general indication subtype into the cond profile.
 * @param indication {{ value: string, type: string }}
 * @param conditionProfile {{}}
 * @return {Promise<{}>}
 */
export const preProcessCondProfile = async (indication, conditionProfile) => {
  let profile = await getInitialConditionProfileByIndication(
    indication.value,
    conditionProfile,
  );

  profile = await removeNonIndicationAttrs(indication, profile);

  if (indication.value !== GENERAL_CONDITION) {
    return profile;
  }

  return mixGeneralRelatedAttrs(indication, profile);
};

/**
 * @param indication {string}
 * @param condProfile {{}}
 * @return {string | null}
 */
export const getGeneraIndicationSubType = (indication, condProfile) => {
  if (indication !== GENERAL_CONDITION) {
    return null;
  }

  const { [SUBTYPE_FIELD_BY_ALL_CONDITIONS[indication]]: subType } = condProfile;
  return subType ?? null;
};
